import { DatabaseFieldType, USER_VALUE_CURRENT } from '@databases/types/database';
import { v4 as uuidv4 } from 'uuid';

/**
 * Adds SDK-managed item IDs to collection values before strict validation.
 */
export function generateValueItemIds(value: unknown): unknown {
  if (
    typeof value !== 'object' ||
    value === null ||
    !('type' in value) ||
    !('value' in value)
  ) {
    return value;
  }

  switch (value.type) {
    case DatabaseFieldType.HYPERLINK:
    case DatabaseFieldType.PAGE_LINK:
    case DatabaseFieldType.JIRA_ISSUE:
    case DatabaseFieldType.USER:
      if (value.value === USER_VALUE_CURRENT || !Array.isArray(value.value)) {
        return value;
      }

      return {
        ...value,
        value: value.value.map(addGeneratedItemId)
      };

    default:
      return value;
  }
}

function addGeneratedItemId(item: unknown): unknown {
  if (typeof item !== 'object' || item === null) {
    return item;
  }

  if ('_id' in item && typeof item._id === 'string') {
    return item;
  }

  return { ...item, _id: uuidv4() };
}
